import React from "react"
import styled, { keyframes } from "styled-components"
import { colors } from "buoy-theme"

const ProgressWrapper = styled.div`
  display: flex;
  width: 100%;
  border-radius: 4px;
  margin: 4px 0 8px;
  height: 6px;
  background-color: ${colors.neutralLighter};
`

const Progress = styled.div`
  background-color: ${colors.primary};
  height: 100%;
  position: relative;
  border-radius: 4px;
  animation: ${props => props.width > 0 && setProgress(props.width)} 0.75s
    linear;
  width: ${props => `${props.width}%`};
`

Progress.defaultProps = {
  width: 0,
}

const setProgress = width => keyframes`
  0% {
    width: 0%;
  }

  75% {
    width: 100%;
  }

  100% {
    width: ${width}%;
  }
`

const ProgressBar = ({ percent }) => (
  <ProgressWrapper>
    <Progress width={percent} />
  </ProgressWrapper>
)

export { ProgressBar as default }



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/ProgressBar.js